import * as z from 'zod'
import { t } from 'i18next'

export const bannerTopSchema = z.object({
  title: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(100, {
      message: t('error:landing_title_length_error') as string,
    }),
  titleInDutch: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(100, {
      message: t('error:landing_title_in_dutch_length_error') as string,
    }),
  subTitle: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(100, {
      message: t('error:landing_sub_title_in_dutch_length_error') as string,
    }),
  subTitleInDutch: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(100, {
      message: t('error:landing_sub_title_in_dutch_length_error') as string,
    }),

  mediaId: z.number({
    required_error: t('error:field_required') as string,
  }),
  mediaMobileId: z.number({
    required_error: t('error:field_required') as string,
  }),
  layout: z.string(),
  textColor: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(10, {
      message: t('error:text_color_length_error') as string,
    }),
  type: z.string(),
})
export type IBannerTop = z.infer<typeof bannerTopSchema>

export const bannerBottomSchema = z.object({
  content: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(255, {
      message: t('error:landing_description_length_error') as string,
    }),
  contentInDutch: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(255, {
      message: t('error:landing_description_length_error') as string,
    }),
  mediaId: z.number({
    required_error: t('error:field_required') as string,
  }),
  mediaMobileId: z.number({
    required_error: t('error:field_required') as string,
  }),
  layout: z.string(),
  textColor: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(10, {
      message: t('error:text_color_length_error') as string,
    }),
  type: z.string(),
})
export type IBannerBottom = z.infer<typeof bannerBottomSchema>
